export const url_base = "https://motoexplorer.wowdesarrollos.com/api"
export const url_ocrend = "https://motoexplorer.wowdesarrollos.com/ocrend/api"
// export const url_base = "http://192.168.1.87/me/api"
// export const url_ocrend = "http://192.168.1.87/me/ocrend/api"